import React, { type HTMLAttributes, type ReactNode } from "react";
import { BaseInputAdornmentContext } from "src/components/BaseInput/BaseInputAdornmentContext.tsx";

export const EndAdornment = ({
  endAdornment,
  disabled = false,
  isButton,
  ...rest
}: {
  endAdornment: ReactNode;
  disabled?: boolean;
  isButton?: boolean;
} & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      onClick={(e) => {
        if (!isButton) {
          e.stopPropagation();
        }
      }}
      {...rest}
    >
      <BaseInputAdornmentContext.Provider
        value={{
          disabled,
          position: "end",
        }}
      >
        {endAdornment}
      </BaseInputAdornmentContext.Provider>
    </div>
  );
};
